export default function designSystemDemoHandler(props, locationState) {
  const { location: { current: { query = {} } = {} } = {} } =
    locationState || {}

  return {
    componentName: 'IndexPage',
    subapp: 'designSystemDemo',
    props: {
      componentKey: query.componentKey,
    },
  }
}
